import {UIElement} from "./ui";
import * as $ from "jquery";
import '/modules/common/css/ui/multioptionlist.css';
import '/modules/common/css/ui/multioptionlist.mobile.css';

class MultiOptionList extends UIElement{

    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param id {string} Dropdown id
     * @param label {String} A main lable for the whole list (can be an HTML element)
     * @param optionsList {AbstractOptionList} A list of option values
     */
    constructor(translator, isMobileDevice, id, label, optionsList) {
        super(id, translator, isMobileDevice, undefined, undefined);
        this.optionsList = optionsList
            .onChange(()=>this._updateLabel())
            .onChangeAvailableValues(()=>this._updateLabel());
        this.label = label;
    }

    getClassName() {
        return "MultiOptionList";
    }

    _updateLabel(){
        const value = this.optionsList.getValue();
        $('.multi-options-list-label label', this.uiElement).html(this.label+' ({0}/{1})'.format([
            value?(Array.isArray(value)?''+value.length:'1'):'0',
            this.optionsList.getMaxSelectable()+''
        ]))
    }

    getUIElement() {
        if(!this.uiElement){
            this.uiElement = $(
                '<div class="multi-options-list">' +
                '   <div class="multi-options-list-label"><label></label></div>' +
                '   <div class="multi-options-list-container"><div class="top"></div><div class="bottom"></div></div>' +
                '</div>'
            ).attr('id',this.id);
            this._updateLabel();
            this.optionsList.getUIElement().insertAfter($('.multi-options-list-container .top',this.uiElement));
        }
        return this.uiElement;
    }
}

class AbstractOptionList extends UIElement {

    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param id {string} Dropdown id
     * @param values {Array<String>} A list of option values
     * @param labels {Array<String>} A list of option labels (can be an HTML element)
     * @param initialValue {string} The initial value
     * @param mandatory {boolean} Is it mandatory to choose a value?
     * @param onChange {function} A callback to be called when the value changes
     */
    constructor(translator, isMobileDevice, id, values, labels, initialValue, mandatory, onChange) {
        super(id, translator, isMobileDevice, undefined, undefined);
        this.value = initialValue;
        this.values = values.slice();
        this.labels = labels.slice();
        this.mandatory = mandatory;
        this.disabledValues = [];

        this.onChangeAvailableValuesCallbacks = new Set();
        this.onChangeCallbacks = new Set();
        this.onChange(onChange);
    }

    getMaxSelectable() {
        return this.getPossibleValues().length;
    }

    onChangeAvailableValues(callback){
        if(callback)
            this.onChangeAvailableValuesCallbacks.add(callback);
        return this;
    }

    disableValues(values2Disable){
        $("input, label",this.uiElement).removeAttr('disabled').removeClass('disabled');
        values2Disable.forEach(v=> $("input[value='"+v+"']",this.uiElement).attr('disabled','disabled').addClass('disabled'));
        values2Disable.forEach(v=> $("label[val='"+v+"']",this.uiElement).addClass('disabled'));
        this.disabledValues = values2Disable;
        this.onChangeAvailableValuesCallbacks.forEach(c=>c());
        return this;
    }

    getPossibleValues(){
        return this.values.filter(v=>this.disabledValues.indexOf(v)<0);
    }

    getCode() {
        return this.id;
    }

    getUIElement() {}

    onChange(callback) {
        if (callback) {
            this.onChangeCallbacks.add(callback);
        }
        return this;
    }

    /**
     * Get current value
     * @return {string}
     */
    getValue() {
        return this.value;
    }

    /**
     * Set the value
     * @param value {string}
     */
    setValue(value){
        this._setValue(value,true);
        return this;
    }

    _setValue(value, triggerOnChange) {}
}


export {MultiOptionList, AbstractOptionList}